<script>
/*
  Teslakala addition — not part of upstream Chatwoot.

  Chatwoot only ever offers to turn on browser push from Profile Settings ->
  Notification Preferences, which nobody ever opens: on 2026-08-25 the account
  had 11 agents and ZERO registered push devices. Email notifications are
  deliberately switched off for this team (the volume was overwhelming), so
  browser push is now the ONLY way a waiting customer reaches a rep.

  This banner asks for the permission on every page until it is granted, and
  reappears a day after being dismissed. The strings are Persian inline rather
  than in the locale files: the component does not exist upstream, so keeping
  them here means one file to carry across an upgrade instead of three.
*/
import Banner from 'dashboard/components/ui/Banner.vue';
import { useAlert } from 'dashboard/composables';
import {
  hasPushPermissions,
  requestPushPermissions,
} from 'dashboard/helper/pushHelper';

const SNOOZE_KEY = 'tk_push_prompt_snoozed_until';
const SNOOZE_HOURS = 24;

export default {
  components: { Banner },
  data() {
    return {
      granted: hasPushPermissions(),
      snoozedUntil: Number(window.localStorage.getItem(SNOOZE_KEY) || 0),
    };
  },
  computed: {
    isSupported() {
      return 'Notification' in window && 'serviceWorker' in navigator;
    },
    // A browser-level block cannot be undone from JavaScript: requestPermission()
    // returns immediately without prompting. Say so instead of offering a button
    // that silently does nothing.
    isBlocked() {
      return this.isSupported && window.Notification.permission === 'denied';
    },
    shouldShowBanner() {
      if (!this.isSupported || this.granted) return false;
      return Date.now() > this.snoozedUntil;
    },
    bannerMessage() {
      return this.isBlocked
        ? 'اعلان مرورگر برای پشتیبانی مسدود شده است. از آیکون کنار آدرس سایت، اعلان‌ها را مجاز کنید تا پیام مشتری‌ها را از دست ندهید.'
        : 'اعلان ایمیل خاموش است. برای اینکه پیام مشتری‌ها را به‌موقع ببینید، اعلان مرورگر را روشن کنید.';
    },
  },
  methods: {
    enable() {
      requestPushPermissions({
        onSuccess: () => {
          this.granted = true;
          useAlert('اعلان مرورگر فعال شد. از این پس پیام‌های جدید را همین‌جا می‌بینید.');
        },
      });
      // Notification.requestPermission resolves through its own callback, so
      // re-read the state shortly after in case the user dismissed the dialog.
      setTimeout(() => {
        this.granted = hasPushPermissions();
      }, 1500);
    },
    snooze() {
      const until = Date.now() + SNOOZE_HOURS * 60 * 60 * 1000;
      window.localStorage.setItem(SNOOZE_KEY, String(until));
      this.snoozedUntil = until;
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="bannerMessage"
    :has-action-button="!isBlocked"
    action-button-label="روشن کردن اعلان"
    action-button-icon="i-lucide-bell"
    has-close-button
    @primary-action="enable"
    @close="snooze"
  />
</template>
